import axios, { AxiosInstance } from 'axios';
import { useAuthStore } from '../store/authStore';
import { apiBaseURL } from './config';

export { apiBaseURL } from './config';

export const createApiClient = (): AxiosInstance => {
  const client = axios.create({
    baseURL: apiBaseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add token to every request
  client.interceptors.request.use((config) => {
    const { token } = useAuthStore.getState();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Handle 401 responses
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        useAuthStore.getState().logout();
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

  return client;
};

export const apiClient = createApiClient();
